import { getBackend } from '@/backend';
import type { OrgMembership } from '@/backend/contracts';

export type {
    OrgMembership,
    OrgMembershipRole,
    OrgMembershipStatus,
} from '@/backend/contracts';

function getOrgMembershipClient() {
    const client = getBackend().orgMemberships;
    if (!client) {
        throw new Error('Organization membership backend client is not configured.');
    }
    return client;
}

export async function getUserOrgMemberships(userId: string): Promise<OrgMembership[]> {
    return getOrgMembershipClient().listUserOrgMemberships(userId);
}

export async function getActiveOrgIdPreference(userId: string): Promise<string | null> {
    return getOrgMembershipClient().getActiveOrgIdPreference(userId);
}
